import React from "react";

function Doctors() {
    const doctors = [
        {
            heading: "Doctors",
        },
        {
            name: "Dr. Venkata Ramarao Kintali",
            position1: "MBBS, DNB, FCD, CTCCM",
            position2: "Senior Medical Officer",
            image: "https://files.iittp.ac.in/images/demo/iit/Staff/ramarao.png",
        },
        {
            name: "Dr. Sruthi Kodidini",
            position1: "MBBS,MD.OBG",
            position2: "Medical Officer",
            image: "https://files.iittp.ac.in/images/demo/iit/Staff/sruthi.jpg",
        },
    ];

    return (
        <>
            {doctors.map((doctor, index) =>
                doctor.heading ? (
                    <h2 className="mb-3" key={index}>
                        {doctor.heading}
                    </h2>
                ) : (
                    <div key={index} className="col-xl-6 col-md-8">
                        <div className="single-team mb-40">
                            <div className="team-thumb">
                                <div className="brd">
                                    <img src={doctor.image} alt="img" />
                                </div>
                            </div>
                            <div className="team-info">
                                <h4>{doctor.name}</h4>
                                <div className="text-dark">
                                    <p>{doctor.position1}</p>
                                    <p className="text-dark">
                                        {doctor.position2}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            )}
        </>
    );
}

export default Doctors;
